/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultCode } from '../../models/result-code';

export interface SaveResultCodes$Params {
      body: ResultCode
}

export function saveResultCodes(http: HttpClient, rootUrl: string, params: SaveResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultCode>> {
  const rb = new RequestBuilder(rootUrl, saveResultCodes.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResultCode>;
    })
  );
}

saveResultCodes.PATH = '/resultcodes';
